import React from 'react'
import { useOfferList } from 'hooks/Offers/useOfferList'
import { MAX_CAROUSEL_ITEM_COUNT } from 'home/components/OfferCarousels/common/constants'
import HeroOfferLoadingCarouselItems from 'home/components/OfferCarousels/HeroOfferLoadingCarouselItems'

const OFFER_TYPES: App.OfferListOfferType[] = ['hotel', 'tactical_ao_hotel', 'last_minute_hotel']
const DEFAULT_FILTERS: App.OfferListFilters = {
  offerTypes: OFFER_TYPES,
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
  sortBy: 'homepage',
}

interface Props {
  hasLFSECarousel: boolean;
  filters?: App.OfferListFilters;
}

function HeroOfferLoadingCarousel({ filters, hasLFSECarousel }: Props) {
  const [offerList] = useOfferList(filters ?? DEFAULT_FILTERS)

  if ((offerList.offerIds.length === 0)) {
    return null
  }

  return <HeroOfferLoadingCarouselItems offerIds={offerList.offerIds} hasLFSETile={hasLFSECarousel} />
}

HeroOfferLoadingCarousel.defaultProps = {
  hasLFSECarousel: true,
}

export default HeroOfferLoadingCarousel
